import { render } from "./AddEditArticleClass.vue?vue&type=template&id=0795b290&scoped=true"
import script from "./AddEditArticleClass.vue?vue&type=script&lang=js"
export * from "./AddEditArticleClass.vue?vue&type=script&lang=js"

import "./AddEditArticleClass.vue?vue&type=style&index=0&id=0795b290&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0795b290"]])

export default __exports__